import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAcknowledgementData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";

const emptyState = (): AOPMaltaAcknowledgementData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  acknowledgmentBody: [],
});

export interface AOPAcknowledgementLetterBasicLayoutProps {
  country: AdmissionOfficeCountry;
}

const AOPAcknowledgementLetterBasicLayout = ({ country }: AOPAcknowledgementLetterBasicLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAcknowledgementData>(emptyState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAcknowledgementData>(emptyState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPAcknowledgementLetterBasicLayout;
